import React, {Component} from "react";
import AppHeader from "./componentsHeader/AppHeader.js";
import applogic from "./applogic.js";

class App extends Component {
    constructor() {
        super();
        if (!applogic.checkIOS() && !applogic.checkIE()) {
            applogic.initApp();
        }
    }

    render() {
        if (applogic.checkIOS()) {
            return (
                <div>
                    <div className="row">
                        <div className="col-md-3"/>
                        <div className="col-md-6">
                            <img src="/img/apple_worm.png" alt="Apple bug" width="100%"
                                 className="img-responsive center-block col-centered"/>
                        </div>
                        <div className="col-md-3"/>
                    </div>
                    <div className="row">
                        <div className="col-md-1"/>
                        <div className="col-md-10 text-center">
                            <h2>This website is not compatible with iOS devices due to the limitation imposed by Apple.<br /><br /></h2>
                            <h1>Please visit this website using Chrome on other devices.<br /><br /></h1>
                            <h2>We apologize for the inconvenience caused.</h2>
                        </div>
                        <div className="col-md-1"/>
                    </div>
                </div>
            );
        }
        if (applogic.checkIE()) {
            return (
                <div>
                    <div className="row">
                        <div className="col-md-4"/>
                        <div className="col-md-4 text-center">
                            <img src="/img/IE_bug.jpg" alt="IE bug"
                                 className="img-responsive center-block col-centered"/>
                        </div>
                        <div className="col-md-4"/>
                    </div>
                    <div className="row">
                        <div className="col-md-1"/>
                        <div className="col-md-10 text-center">
                            <h2>This website is not compatible with IE due to lack of MediaSource extension <br /><br /></h2>
                            <h1>Please use Chrome to get the best experience</h1>
                            <a href="https://www.google.com/chrome/"><img src="/img/chrome.png" alt="Chrome"
                                 className="img-responsive center-block col-centered"/></a>
                            <h2>We apologize for the inconvenience caused.</h2>
                        </div>
                        <div className="col-md-1"/>
                    </div>
                </div>
            )
        }
        return (
            <div>
                <AppHeader />
                {this.props.children}
            </div>
        );
    }
}
export default App;



// WEBPACK FOOTER //
// ./src/App.js